import { Account, Contract, RecruitmentAgency } from "@timesheets/constants-common";
import { IById, IWebApplication, Routing } from "@timesheets/webapp-support";
import { ICreatedEvent, IEvent } from "@gemma/events";
import { Reminders, Roles } from "@timesheets/routes-app";
import { ViewEvents, WireEntities } from "@timesheets/common";

import { IState } from "../vuex/IState";
import { Route } from "@gemma/utils";
import { Store } from "vuex";
import { TRouteMetaGroup } from "../routing";
import Vue from "vue";
import VueRouter from "vue-router";
import { WebApplicationConstants } from "./WebApplicationConstants";

export function registerSubscriptions(router: VueRouter, store: Store<IState>, webApplication: IWebApplication<Route<TRouteMetaGroup>>) {
  WebApplicationConstants.eventBus //
    .createFilters([Account.CreateAuthorisingRole, Account.CreateContractingRole, Account.CreateRecruitmentAgencyAdministrationRole])
    .addSubscription(
      async (event: ICreatedEvent<{ id: string; accountId: string }, string, string>) => {
        if (event.data.accountId === store.state.currentSession.account.id) {
          await store.dispatch("user/loadProfile", { webApplication, notify: true });
          const role = store.state.user.roles.find(role => role.id === event.data.id);
          if (role) {
            let roleType;
            switch (event.type) {
              case Account.CreateContractingRole.EventName:
                roleType = "contracting";
                break;

              case Account.CreateAuthorisingRole.EventName:
                roleType = "authorising";
                break;

              case Account.CreateRecruitmentAgencyAdministrationRole.EventName:
                roleType = "recruitment agency administration";
                break;
            }

            Vue.prototype.$notify("general", `You have a new ${roleType} role for ${role.recruitmentAgency.names.display}`, { duration: 5000 });
          }
        }
      },
      undefined,
      WebApplicationConstants
    );

  WebApplicationConstants.eventBus //
    .createFilter(RecruitmentAgency.Administrator.SetAdministratorEnabled)
    .addSubscription(
      (event: IEvent<{ isEnabled: boolean; role: IById }, string>) => {
        store.dispatch("user/setRoleEnabled", { role: event.data.role, router, isEnabled: event.data.isEnabled });
      },
      undefined,
      WebApplicationConstants
    );

  WebApplicationConstants.eventBus //
    .createFilter(RecruitmentAgency.Administrator.SetSuperAdministrator)
    .addSubscription(
      (event: IEvent<{ isSuperAdministrator: boolean; role: WireEntities.Roles.IRecruitmentAgencyRole }, string>) => {
        store.dispatch("user/setSuperAdministrator", {
          role: event.data.role,
          isSuperAdministrator: event.data.isSuperAdministrator,
        });
      },
      undefined,
      WebApplicationConstants
    );

  WebApplicationConstants.eventBus //
    .createFilter("AuthorisingRole.isEnabled")
    .addSubscription(
      async (event: IEvent<{ isEnabled: boolean; authorisingRoleId: string }, string>) => {
        const role = store.state.user.roles.find(role => role.id === event.data.authorisingRoleId);
        if (role) {
          store.dispatch("user/setRoleEnabled", { role, router, isEnabled: event.data.isEnabled, notify: true });
        }
      },
      undefined,
      WebApplicationConstants
    );

  WebApplicationConstants.eventBus //
    .createFilter("ContractingRole.isEnabled")
    .addSubscription(
      async (event: IEvent<{ isEnabled: boolean; contractingRoleId: string }, string>) => {
        const role = store.state.user.roles.find(role => role.id === event.data.contractingRoleId);
        if (role) {
          store.dispatch("user/setRoleEnabled", { role, router, isEnabled: event.data.isEnabled, notify: true });
        }
      },
      undefined,
      WebApplicationConstants
    );

  WebApplicationConstants.eventBus //
    .createFilter("Profile.role.hasContractors")
    .addSubscription(
      async (event: IEvent<{ hasContractors: boolean; roleId: string }, string>) => {
        const role = store.state.user.roles.find(role => role.id === event.data.roleId);
        if (role) {
          store.dispatch("user/setRoleHasContractors", { role, hasContractors: event.data.hasContractors });
        }
      },
      undefined,
      WebApplicationConstants
    );

  WebApplicationConstants.eventBus //
    .createFilter(Contract.CreateContractor)
    .addSubscription(
      async (event: IEvent<{ contractingRoleId: string }, string>) => {
        const contractingRole = store.state.user.roles.find(role => role.id === event.data.contractingRoleId);
        if (contractingRole && !contractingRole.isEnabled) {
          await store.dispatch("user/loadProfile", { webApplication, notify: true });
        }
      },
      undefined,
      WebApplicationConstants
    );

  WebApplicationConstants.eventBus //
    .createFilter(RecruitmentAgency.SetNames.EventName)
    .addSubscription(
      async () => {
        await store.dispatch("user/loadProfile", { webApplication, forceSet: true });
      },
      undefined,
      WebApplicationConstants
    );

  // Todo: Move to webapp-support listener
  WebApplicationConstants.listenerEventBuses.application
    //
    .on(
      ViewEvents.Roles.RecruitmentAgencyAdministrationRole.IsBetaAccessOnSet.EventName,
      (event: ViewEvents.Roles.RecruitmentAgencyAdministrationRole.RecruitmentAgencyAdministrationRoleEvent<ViewEvents.Roles.RecruitmentAgencyAdministrationRole.IsBetaAccessOnSet.IIsBetaAccessOnSet>) => {
        const isBetaAccessOn = event.data;
        if (
          //
          !isBetaAccessOn &&
          store.state.user.currentRole &&
          store.state.user.currentRole.id === event.recruitmentAgencyAdministrationRoleId &&
          router.currentRoute.path.startsWith(Reminders.Root)
        ) {
          const route = new Route(Roles.Root);
          Routing.ensureRoleIdOnUrl(route, store.state.user.currentRole);
          router.push(route.fullPath).catch(() => {});
        }

        store.dispatch("user/setIsBetaAccessOn", {
          recruitmentAgencyAdministrationRoleId: event.recruitmentAgencyAdministrationRoleId,
          isBetaAccessOn,
        });
      },
      WebApplicationConstants
    );
}
